import React from "react";
import MonthlySchedule from "../site/MonthlySchedule";
import { ShieldCheck } from "lucide-react";

export default function AdminBlockDates() {
  return (
    <div className="space-y-6" data-testid="admin-block-dates-page">
      <div>
        <p className="overline mb-2">Reservations</p>
        <h1 className="font-serif-display text-3xl md:text-4xl tracking-tight">
          Block Dates
        </h1>
        <p className="text-[#A1A4B5] text-sm mt-2 max-w-2xl">
          Reserve the villa for your personal use. Click any open date below — it'll
          be saved instantly as an Overnight Use block, with no payment required.
          Booked dates will appear automatically on the public schedule.
        </p>
      </div>

      <div className="rounded-xl border border-[#C5A059]/30 bg-[#C5A059]/5 p-4 flex items-start gap-3">
        <ShieldCheck size={18} className="text-[#C5A059] mt-0.5" />
        <div className="text-xs text-[#E5E7EB] leading-relaxed">
          <span className="text-[#C5A059] font-semibold uppercase tracking-[0.16em] text-[10px] block mb-1">
            Owner Mode Active
          </span>
          Every booking made from this page is auto-confirmed as an owner block. No
          payment proof, no contact details collected.
        </div>
      </div>

      <MonthlySchedule forceOwnerMode={true} />
    </div>
  );
}
